import { ConfigService } from '@axo/config/ConfigService';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { MaritalStatus } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { Message } from '@axo/ui-core/components/Message';
import { useFormContext } from 'react-hook-form';
import { useBroker } from '../../../../../../hooks/useBroker';
import { formatSpacedNumber } from '../../../../../../utils/format';
import { PartnerFormGroupData } from '../../../../FormData.fi.types';
import {
  amountOfChildrenOptions,
  maritalStatusOptions,
} from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import styles from '../../../loan.module.scss';
import {
  amountOfChildrenFieldOptions,
  maritalStatusFieldOptions,
  partnerGrossIncomeFieldOptions,
  partnerLivingCostMonthlyFieldOptions,
} from './config';

export const PartnerFormGroup = () => {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasPartnerLivingCostMonthly } = ConfigService.get(
    'product-unsecured-loan'
  ).fields[broker];

  const { watch } = useFormContext();

  const [maritalStatus, partnerGrossIncome] = watch([
    'LoanApplication/MaritalStatus',
    'Frontend/PartnerGrossIncomeMonthly',
  ]);

  const askPartnerDetails = [
    MaritalStatus.Married,
    MaritalStatus.Cohabiting,
  ].includes(maritalStatus);

  return (
    <>
      <div className={styles.inputGroup} data-grey={true}>
        <Grid columns={gridColumns}>
          <DropdownFieldUI<PartnerFormGroupData>
            name="LoanApplication/MaritalStatus"
            label={t('MaritalStatus.label')}
            data-testid="marital-status-input"
            options={maritalStatusOptions}
            {...maritalStatusFieldOptions}
          />

          {askPartnerDetails && (
            <>
              <NumberFieldUI<PartnerFormGroupData>
                name="Frontend/PartnerGrossIncomeMonthly"
                label={t('PartnerGrossIncomeMonthly.label')}
                data-testid="partner-gross-income-monthly-input"
                format={formatSpacedNumber}
                suffix={t('suffix.currency')}
                {...partnerGrossIncomeFieldOptions}
              />

              {hasPartnerLivingCostMonthly && (
                <NumberFieldUI<PartnerFormGroupData>
                  name="LoanApplication/PartnerLivingCostMonthly"
                  label={t('PartnerLivingCostMonthly.label')}
                  data-testid="partner-living-cost-monthly-input"
                  format={formatSpacedNumber}
                  suffix={t('suffix.currency')}
                  {...partnerLivingCostMonthlyFieldOptions}
                />
              )}
            </>
          )}
        </Grid>
      </div>

      {askPartnerDetails && !Number(partnerGrossIncome) && (
        <Message variant="warn" hasIcon>
          {t('PartnerGrossIncomeMonthly.message')}
        </Message>
      )}

      <Grid columns={gridColumns}>
        <DropdownFieldUI<PartnerFormGroupData>
          name="AmountOfChildren"
          label={t('AmountOfChildren.label')}
          data-testid="amount-of-children-input"
          options={amountOfChildrenOptions}
          {...amountOfChildrenFieldOptions}
        />
      </Grid>
    </>
  );
};
